import styles from 'sections/welcomeAnim/whatIsItFor/whatIsItFor.module.css';
import generalStyles from 'index.module.css';

import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { OptimizedImg } from 'components/optimizedImg/OptimizedImg';
import { AnimatedImg } from 'components/animatedImg/AnimatedImg';
import { picsUrls } from 'sections/welcomeAnim/whatIsItFor/whatIsItFor.util';
import { useGetWhatIsItFor } from 'sections/welcomeAnim/whatIsItFor/getWhatIsItFor.hooks';

export const WhatIsItFor = () => {
    const { t } = useTranslation();
    const whatIsItForData = useGetWhatIsItFor();

    return (
        <section
            id="section-what-is-it-for"
            className={`${generalStyles.heightAuto} ${styles.whatIsItForSection}`}
        >
            <Element name="whatsIsItFor">
                <div className={generalStyles.container}>
                    <div className={styles.whatIsItFor}>
                        <div className={styles.whatIsItFor__info}>
                            <h3 className={styles.info__title}>
                                {t('welcomeAnim.whatIsItFor.whatIsItForTitle')}
                            </h3>
                            <ul className={styles.whatIsItFor__infoList}>
                                {whatIsItForData.map(({ step }) => {
                                    return (
                                        <li
                                            key={step}
                                            className={styles.info__step}
                                        >
                                            {step}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        <div className={styles.whatIsItFor__pics}>
                            {picsUrls.map(({ desktopSrc, mobileSrc, id }) => {
                                return (
                                    <div
                                        key={id}
                                        className={styles.whatIsItFor__pic}
                                    >
                                        <AnimatedImg>
                                            <OptimizedImg
                                                desktopSrc={desktopSrc}
                                                mobileSrc={mobileSrc}
                                            />
                                        </AnimatedImg>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </Element>
        </section>
    );
};
